import React from "react";
import style from "./conditionsList.module.scss";

function ConditionsList() {

  return (
    <div className={style.conditionsList}>
      <div className="container">

        <h2 className={style.conditionsList__title}>Conditions treated include, but are not limited to</h2>

        <div className={style.conditionsList__content}>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Pain</h3>
            <p className={style.conditionsList__contentText}>back, spine, knee, and ankle pain, frozen shoulder, sciatica, neck pain and stiffness, carpal tunnel syndrome, osteoarthritis, tennis and golfer's elbow, headache and migraines, dental pain and TMJ
            </p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Gastrointestinal disorders
            </h3>
            <p className={style.conditionsList__contentText}>GERD, IBS, Crohn’s and Colitis, diarrhea, constipation, nausea and vomiting
            </p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Systemic and autoimmune disorders
            </h3>
            <p className={style.conditionsList__contentText}>high blood pressure, diabetes, fibromyalgia, rheumatoid arthritis, lupus, chronic fatigue, and multiple sclerosis
            </p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Respiratory problems</h3>
            <p className={style.conditionsList__contentText}>colds and flu, cough, allergies, asthma</p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Gyn and pregnancy related issues</h3>
            <p className={style.conditionsList__contentText}>irregular, heavy, or painful menstruation, PMS,
              fertility issues, menopausal problems, morning sickness, edema, fatigue, amenorrhea, PCOS, endometriosis</p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Urogenital disorders
            </h3>
            <p className={style.conditionsList__contentText}>urinary tract problems, sexual dysfunction
            </p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Sleep and stress
            </h3>
            <p className={style.conditionsList__contentText}>insomnia, nervous tension, low energy
            </p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Mental health
            </h3>
            <p className={style.conditionsList__contentText}>depression, anxiety, OCD, PTSD
            </p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Cancer treatment support
            </h3>
            <p className={style.conditionsList__contentText}>treatment of pain, burns, scars, nausea, and fatigue due to chemotherapy and radiation, palliative care
            </p>
          </div>
          <div className={style.conditionsList__contentItem}>
            <h3 className={style.conditionsList__contentTitle}>Pediatric acupuncture</h3>
            <p className={style.conditionsList__contentText}></p>
          </div>
        </div>

      </div>

    </div>
  )
}

export default ConditionsList;